import React, { useState, useMemo, useRef, useEffect } from 'react';
import { Card, Col, Row, ButtonGroup, Button, Tabs, Tab } from 'react-bootstrap'

import Map, { Source, Layer, Marker, } from 'react-map-gl';
//import {MyPiePlot} from './PiePlot'

import { MyPiePlot } from './PiePlot_recharts'
import { MyHorizontalBarPlot } from './HorizontalBarChart_recharts'
// import { ModalScenarioSelection } from './modalScenarioSelection'
// import { ModalScenarioInfo } from './modalScenarioInfo'
// import { ModalRegionSelection } from './modalRegionSelection'
// import { ModalInfo } from './modalInfo'
// import splitArrowInfo from './splitArrowInfo.svg'

import { FaChartLine, FaRoute, FaInfo, FaExternalLinkAlt } from 'react-icons/fa'
import { GiHarborDock } from 'react-icons/gi'
import { TimeSeriesCharts } from './TimeSeriesCharts';
import { TimeSlider } from './timeSlider'
import { Link } from 'react-router-dom'
import { ItemDropdown } from './itemDropdown'
import { FuelTable } from './fuelTableBs'
import { CardTimeseriesSelection } from './cardTimeseriesSelection';
import PortPlot from './PortPlot';
import { MapLegend } from './mapLegend'

import { ScenarioDescription } from './scenarioDescription';
import ShipList from './ShipList';
import { CardRouteParamSelection } from './cardRouteParamSelector';



// import { MyLinePlot } from './LinePlot'
// import Chart from 'chart.js/auto';

//const MAP_STYLE = 'https://basemaps.cartocdn.com/gl/dark-matter-nolabels-gl-style/style.json';


export const MapboxPlot = ({ data, max_TOTAL, setScenario, scenario, scenarioes,
  overallData, overallFueltypes, portsFueltypes, month, setMonth, year,
  setYear, descriptionData, fuelTypeInfo, regions, region, setRegion, portsData, startDate, 
  endDate, fleets, fleet, setFleet,routeData,
  routeDataParameters,  routeDataParameter, setRouteDataParameter }) => {
// console.log(overallData)
  const [charts, setCharts] = useState([{ id: 0, name: "Fuel Consumption", checked: true },
                                          { id: 1, name: "CO2eq GWP100 Emission", checked: true },
                                          { id: 2, name: "Fuel Price", checked: true },
                                          { id: 3, name: "Transport Capacity", checked: true },
                                          { id: 4, name: "Number of Sailing Ships", checked: false },
                                          { id: 5, name: "Number of Bunkering Events", checked: false },
                                          { id: 6, name: "CAPEX", checked: false },
                                          { id: 7, name: "OPEX", checked: false },
                                          { id: 8, name: "Average Speed", checked: false },
                                          { id: 9, name: "Electric Energy Demand", checked: false }])

  const mapRef = useRef()
  // const [viewport, setViewport] = useState({
  //   latitude: 37.7577, // Initial latitude
  //   longitude: -122.4376, // Initial longitude
  //   zoom: 10 // Initial zoom level
  // });


  const [dateList, setDateList] = useState([])
  const [showPortPlot, setShowPortPlot] = useState(false);
  const [portPlotData, setPortPlotData] = useState()
  // const [selectedPort, setSelectedPort] = useState("")

  const [mode, setMode] = useState('CHART')

  //const [showScenarioInfo, setShowScenarioInfo] = useState(false)

  const getMonthName = (m) => {
    switch (m) {
      case 1:
        return { short: 'Jan', long: 'January' }
      case 2:
        return { short: 'Feb', long: 'February' }
      case 3:
        return { short: 'Mar', long: 'March' }
      case 4:
        return { short: 'Apr', long: 'April' }
      case 5:
        return { short: 'May', long: 'May' }
      case 6:
        return { short: 'June', long: 'June' }
      case 7:
        return { short: 'July', long: 'July' }
      case 8:
        return { short: 'Aug', long: 'August' }
      case 9:
        return { short: 'Sep', long: 'September' }
      case 10:
        return { short: 'Oct', long: 'October' }
      case 11:
        return { short: 'Nov', long: 'November' }
      case 12:
        return { short: 'Dec', long: 'December' }
      default:
        return { short: 'Jan', long: 'January' }

    }
  }

  useEffect(()=> {
    const dates = [startDate]
    let _month = startDate.clone(); //clone the startDate
    while( _month < endDate ) {
        _month.add(1, "month");
        dates.push(_month.clone());
    }
    setDateList(dates)

  }, [startDate, endDate])
  const buttonCard = useMemo(() => {
    return (
      // <Card
      //   style={{
      //     position: 'absolute',
      //     top: 50,
      //     left: 20,
      //     alignContent: 'center'
      //   }}>
      <ButtonGroup vertical
        style={{
          position: 'absolute',
          top: 70,
          left: 20,
          alignContent: 'center'
        }}>
        {/* <ModalScenarioInfo scenario={scenario} showScenarioInfo={showScenarioInfo} ScenarioDescription={descriptionData} /> */}
        {/* <ModalInfo fuelTypes={overallFueltypes} fuelTypeInfo={fuelTypeInfo} /> */}
        {/*<ModalRegionSelection />
        <ModalScenarioSelection scenarioes={scenarioes} setScenario={setScenario} />
        <ModalScenarioInfo scenario={scenario} showScenarioInfo={showScenarioInfo} /> */}
        {/* <Button variant="secondary" onClick={() => setShowScenarioInfo(true)} >
            <img src={splitArrowInfo} height={30} />
          </Button> */}

        <Button variant="secondary" onClick={() => setMode('INFO')} >
          <FaInfo size={25} />
        </Button>

        <Button variant="secondary" onClick={() => setMode('CHART')} >
          <FaChartLine size={25} />
        </Button>
        <Button variant="secondary" onClick={() => setMode('PORT')} >
          <GiHarborDock size={30} />
        </Button>
        {routeData &&
        <Button variant="secondary" onClick={() => setMode('ROUTE')} >
          <FaRoute size={25} />
        </Button>
        }
      </ButtonGroup>
      // </Card>
    )
  }, [routeData]);

  // useEffect(()=>{
  //   if (mode === "PORT" && fleet && fleet.id !== 0) {
  //     setFleet({id: 0, name: 'All', fleet: 'all'})
  //   }
  // },[mode, fleet, setFleet])

  useEffect(() => {
    if (!!mapRef.current) {
      mapRef.current.jumpTo({ center: [region.center.longitude, region.center.latitude], zoom: region.center.zoom })
    }

  }
    , [region])

  const onMapLoad = React.useCallback(() => {
    mapRef.current.jumpTo({ center: [region.center.longitude, region.center.latitude], zoom: region.center.zoom })
  }, [region.center]);

  const openPortPlot = (locode) => {
    const _portsData = portsData.data.filter(el => el.locode === locode)
    const _portsDataFull = []
    const _defaultItem = {..._portsData[0]}
    overallFueltypes.forEach(ft => {
      _defaultItem[ft.name] = 0
    })
    dateList.forEach(dt => {
      const correspondingDate = _portsData.filter(el => el.year === dt.year() && el.month === dt.month() + 1)
      if (correspondingDate.length) {
        _portsDataFull.push(correspondingDate[0])
      } else {
        _portsDataFull.push({..._defaultItem, year: dt.year(), month: dt.month() + 1})
      }
    })
    setPortPlotData(_portsDataFull);
    setShowPortPlot(true);
    // setSelectedPort(locode);
  }


  return (
    <React.Fragment>
      <Map
        ref={mapRef}
        onLoad={onMapLoad}
        style={{ height: "100vh", width: "100vw" }}
        mapboxAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
        interactiveLayerIds={['routedata_layer']}

        // longitude={10}
        // latitude={48}
        // // center={[region.center.longitude,region.center.latitude]}
        // zoom={5}

        mapStyle="mapbox://styles/appadmins/clrrv1m1y005x01qvc3gldlki"
      >

        {mode === 'PORT' ?

          data.map((p) =>
            <Marker longitude={p.lon} latitude={p.lat} anchor="center" key={p.locode}  >

              <MyPiePlot key={`pieplot-${p.locode}`} port_data={p} fuelTypes={portsFueltypes} fuelTypeInfo={fuelTypeInfo} onClick={openPortPlot} />

            </Marker>
          )
          :
          <div />
        }
        <Source id="waterways"
          type="geojson"
          data={require("./waterways.geojson")}>

          <Layer
            id='waterways_layer'
            type='line'

            layout={{
              // Make the layer visible by default.
              visibility: mode === 'PORT' ? 'visible' : 'none'
            }}
            paint={{
              'line-color': '#4682B4',
              // 'line-opacity': 0.5,
              'line-width': 2
            }}

            />
          </Source>
          <Source id="greece"
            type="geojson"
            data={require("./greece.geojson")}>

            <Layer
              id='greece_layer'
              type='line'

              layout={{
                // Make the layer visible by default.
                visibility: 'visible'
              }}
              paint={{
                'line-color': '#4682B4',
                // 'line-opacity': 0.5,
                'line-width': 2
              }}

            />
          </Source>
        {routeData &&
        <Source id="routedata"
          type="geojson"
          data={routeData}>

          <Layer
            id='routedata_layer'
            type='line'

            paint={{
              'line-color': [
                'interpolate',
                ['linear'],
                ['get', 'value'], // Property in GeoJSON with values for the gradient
                routeDataParameter.minColorVal, // Minimum value for the gradient
                'white', // Color corresponding to the minimum value
                routeDataParameter.maxColorVal, // Maximum value for the gradient
                'red' // Color corresponding to the maximum value
              ],


              'line-width': 4
            }}

            layout={{
              // Make the layer visible by default.
              visibility: mode === 'ROUTE' ? 'visible' : 'none'
            }}


          />
        </Source>
        }



      </Map>

      {showPortPlot &&

        <PortPlot portData={portPlotData} showPortPlot={showPortPlot} setShowPortPlot={setShowPortPlot} fuelTypeInfo={fuelTypeInfo} overallFueltypes={overallFueltypes} />

      }

      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        height: 50,
        padding: 10,
        paddingRight: 20,
        gap: 10
      }} className='d-flex flex-row flex-wrap'>

        <Link className="custom-link" style={{ width: 100, textAlign: 'right' }} to='/'>Home</Link>
        <Link className="custom-link" style={{ width: 170, textAlign: 'right' }} to='https://waterborne.eu/projects/coordination-projects/needs/documents'>Project deliverables <FaExternalLinkAlt size={'0.7em'}/></Link>
        <Link className="custom-link" style={{ width: 100, textAlign: 'right' }} to='/dashboard'>Dashboard</Link>

      </div>

      {mode === 'INFO' ?
        <Card
          style={{
            position: 'absolute',
            top: 70,
            right: 20,
            width: '80vw',
            alignContent: 'center',
            maxHeight: 'calc(100vh - 100px)',
            // overflow: 'auto'
          }}>
          <Card.Header as="h5">
            Information
          </Card.Header>
          <Card.Body style={{ maxHeight: 800, overflowY: 'auto' }}>
            <Tabs
              defaultActiveKey="fuel"
              id="uncontrolled-tab-example"
              className="mb-3"
            >
              <Tab eventKey="fuel" title="Energy carriers information">
                <>
                <p>More information on energy carriers can be found on <a href="https://sustainablepower.application.marin.nl">sustainablepower.application.marin.nl</a></p>
                <FuelTable fuelTypes={overallFueltypes} fuelTypeInfo={fuelTypeInfo} />
                </>
              </Tab>
              <Tab eventKey="sim" title="Simulation">
              <ScenarioDescription data={descriptionData} fuelTypeInfo={fuelTypeInfo}/>
              </Tab>
              <Tab eventKey="ships" title="Ships">
                <ShipList data={descriptionData} portData={portsData.data}/>
              </Tab>
            </Tabs>

          </Card.Body>
        </Card>
        :
        <div />


      }



      {mode === 'PORT' ?
        <Card
          style={{
            position: 'absolute',
            top: 70,
            right: 50,
            width: '25vw',
            minWidth: 450,
            alignContent: 'center'
          }}>
          <Card.Header as="h5">
            <Row>
              <Col>
                Monthly Bunkered Fuel (MWh)
              </Col>
            </Row>
            <Row>
              <Col>
                <h5> {`${getMonthName(month).long} - ${year}`}</h5>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body className="d-flex justify-content-end">
            <MyHorizontalBarPlot data={data.slice(0, 10)} max_xaxis={max_TOTAL} fuelTypes={portsFueltypes} fuelTypeInfo={fuelTypeInfo} />
          </Card.Body>
        </Card>
        :
        <div />
      }

      {mode === 'PORT' | mode === 'ROUTE' ?
        <div
          style={{
            position: 'absolute',
            bottom: 30,
            width: '100vw',
            alignContent: 'center'
          }}>
          {/* <Card.Body className="d-flex justify-content-end"> */}
          <TimeSlider month={month} setMonth={setMonth} year={year} setYear={setYear} startDate={startDate} endDate={endDate}/>
          {/* </Card.Body> */}
        </div>
        :
        <div />
      }



      {mode === 'CHART' ?
        <Card
          style={{
            position: 'absolute',
            top: 70,
            right: 20,
            width: 'calc(80vw - 60px)',
            maxHeight: 'calc(100vh - 100px)',
            alignContent: 'center'
          }}>
          {/* <Card.Header as="h5">
            <Row>
              <Col md={1}>
                Scenario:
            </Col>
              <Col md={5}>
                <b>{scenario.name} </b>
              </Col>
            </Row>
          </Card.Header> */}
          <Card.Body className="d-flex justify-content-end" style={{ overflowY: 'auto' }}>
            <TimeSeriesCharts overallData={overallData} overallFueltypes={overallFueltypes} fuelTypeInfo={fuelTypeInfo} charts={charts} setCharts={setCharts} />
          </Card.Body>
        </Card>
        :
        <div />
      }

      <div style={{
        position: 'absolute',
        top: 0,
        height: 70,
        padding: 10,
        paddingLeft: 20,
        gap: 10
      }} className='d-flex flex-row flex-wrap' >

      <p style={{ color: "white" }}> <b>Region:</b></p>
      <ItemDropdown item={region} items={regions} setItem={setRegion} />
      <p style={{ color: "white" }} > <b>Scenario:</b></p>
      <ItemDropdown item={scenario} items={scenarioes} setItem={setScenario} />
      {fleets && mode !== "PORT" && mode !== "ROUTE" &&
      <>
      <p style={{ color: "white" }} > <b>Fleet:</b></p>
      <ItemDropdown item={fleet} items={fleets.sort((a,b)=>a.name.localeCompare(b.name))} setItem={setFleet}/>
      </>
      }
       </div>


      {buttonCard}


      {mode === 'CHART' ?
        <CardTimeseriesSelection charts={charts} setCharts={setCharts} overallFueltypes={overallFueltypes} overallData={overallData} fuelTypeInfo={fuelTypeInfo} scenario={scenario} fleet={fleet}/>
        :
        <div />}


      {mode === "ROUTE" ?
        <CardRouteParamSelection routeDataParameters={routeDataParameters}  setRouteDataParameter={setRouteDataParameter}  routeDataParameter={routeDataParameter}/>
        :
        <div />

      }

      {mode === "ROUTE" && routeDataParameters ?
        <MapLegend colorRange={["white", "red"]} numColors={20} maxValue={routeDataParameter.maxColorVal} minValue={routeDataParameter.minColorVal} parameterUnit={routeDataParameter.unit}/>
        :
        <div />

      }

    </React.Fragment>)

}
